import { buildModelManager } from "../builder.js";
const DefaultShopifyCartLineItemSelection = {
  __typename: true,
  id: true,
  cartId: true,
  createdAt: true,
  discountedPrice: true,
  discountedPriceSet: true,
  discounts: true,
  giftCard: true,
  grams: true,
  key: true,
  linePrice: true,
  linePriceSet: true,
  originalLinePrice: true,
  originalLinePriceSet: true,
  originalPrice: true,
  price: true,
  priceSet: true,
  productId: true,
  properties: true,
  quantity: true,
  shopId: true,
  sku: true,
  taxable: true,
  title: true,
  totalDiscount: true,
  totalDiscountSet: true,
  updatedAt: true,
  variantId: true,
  vendor: true
};
const modelApiIdentifier = "shopifyCartLineItem";
const pluralModelApiIdentifier = "shopifyCartLineItems";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyCartLineItemSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyCartLineItemSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCartLineItemSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCartLineItemSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCartLineItemSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCartLineItemSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCartLineItemSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByKey",
    findByField: "key",
    findByVariableName: "key",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCartLineItemSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByKey",
    findByField: "key",
    findByVariableName: "key",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCartLineItemSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "deleteShopifyCartLineItem",
    operationReturnType: "DeleteShopifyCartLineItem",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteShopifyCartLineItems",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "shopifyCartLineItemGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
operations.push(...["create", "bulkCreate", "update", "bulkUpdate"].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyCartLineItem does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyCartLineItemManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyCartLineItemSelection,
  operations
);
export {
  DefaultShopifyCartLineItemSelection,
  ShopifyCartLineItemManager
};
//# sourceMappingURL=ShopifyCartLineItem.js.map
